const PredictorAction = {
  STEP_SELECT: 'STEP_SELECT',
  STEP_FORWARD: 'STEP_FORWARD',
  STEP_BACK: 'STEP_BACK',
  RESTART: 'RESTART',
};

export default PredictorAction;
